import { useBackgroundTasksSafe } from "providers/background-tasks";
import { useWorkspaceIdentifiers } from "hooks/useWorkspace/useWorkspaceIdentifiers";

/** Projects still being created in the background for the current workspace. */
export const usePendingProjectTasks = () => {
  const backgroundTasks = useBackgroundTasksSafe();
  const { workspaceId } = useWorkspaceIdentifiers();
  const tasks = (backgroundTasks?.createProjectTasks ?? []).filter(
    (task) =>
      task.mode === "project" &&
      task.status !== "done" &&
      (!workspaceId || !task.workspaceId || String(task.workspaceId) === String(workspaceId))
  );
  return { tasks, backgroundTasks };
};
